import {
  addDays,
  addMonths,
  addYears,
  endOfMonth,
  isSameDay,
  subDays,
  subMonths,
  subYears
} from 'date-fns';

export const subYearsNumber = (date: Date, amount: number) => {
  return subYears(date, amount);
};

export const addYearsNumber = (date: Date, amount: number) => {
  return addYears(date, amount);
};

export const gateLastDayOfMonth = (date: Date) => {
  return endOfMonth(date);
};

export function getFirstDayOfMonth(date: Date, isValid?: (date: Date) => boolean): Date {
  let day = new Date(date.getFullYear(), date.getMonth(), 1, 12);
  if (isValid) {
    while (!isValid(day)) {
      day = addDays(day, 1);
    }
  }
  return day;
}

export const nextMonthDateInSameDayWeek = (date: Date, isValidDate: (date: Date) => boolean) => {
  let nextDate = addMonths(date, 1);
  let firstDay = getFirstDayOfMonth(nextDate);

  if (isValidDate(firstDay)) {
    while (!isValidDate(nextDate) && !isSameDay(firstDay, nextDate)) {
      nextDate = subDays(nextDate, 1);
    }
    return nextDate;
  } else {
    return date;
  }
};

export const previousMonthDateInSameDayWeek = (
  date: Date,
  isValidDate: (date: Date) => boolean
) => {
  let previousDate = subMonths(date, 1);
  let lastDay = gateLastDayOfMonth(previousDate);

  if (isValidDate(lastDay)) {
    while (!isValidDate(previousDate) && !isSameDay(lastDay, previousDate)) {
      previousDate = addDays(previousDate, 1);
    }
    return previousDate;
  } else {
    return date;
  }
};
